import React from "react";
import { informations } from "../data/SiteData";
function Header(props) {
  return (
    <header id="header" class="d-flex align-items-center">
      <div class="container d-flex align-items-center justify-content-between">
        <h3 style={{ color: "#444444" }}>{informations.title}</h3>

        <nav id="navbar" class="navbar">
          <ul>
            <li>
              <a class="nav-link scrollto active" href="#hero">
                Home
              </a>
            </li>
            <li>
              <a class="nav-link scrollto" href="#about">
                About
              </a>
            </li>
            <li class="dropdown">
              <a class="nav-link scrollto" href="#services">
                <span>Services</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul>
                <li>
                  <a href="#services">Website Development</a>
                </li>
                <li>
                  <a href="#services">Mobile Application</a>
                </li>
                <li>
                  <a href="#services">Custome Solutions</a>
                </li>
                <li>
                  <a href="#services">E-Commerce</a>
                </li>
                <li class="dropdown">
                  <a href="./courses.html">
                    <span>Trainings</span> <i class="bi bi-chevron-right"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="#">HTML5,CSS3,Bootstrap4</a>
                    </li>
                    <li>
                      <a href="#">MERN-Stack</a>
                    </li>
                    <li>
                      <a href="#">PHP</a>
                    </li>
                    <li>
                      <a href="#">MySQL</a>
                    </li>
                    <li>
                      <a href="#">MongoDB</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="dropdown">
              <a class="nav-link scrollto" href="#portfolio">
                <span>Portfolio</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul>
                <li>
                  <a href="#">Website Development</a>
                </li>
                <li>
                  <a href="#">Mobile Application</a>
                </li>
                <li>
                  <a href="#">Custome Solutions</a>
                </li>
                <li>
                  <a href="#">E-Commerce</a>
                </li>
              </ul>
            </li>
            <li class="dropdown">
              <a class="nav-link scrollto" href="./courses.html">
                <span>Courses</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul>
                <li>
                  <a href="#">HTML5,CSS3,Bootstrap4</a>
                </li>
                <li>
                  <a href="#">MERN-Stack</a>
                </li>
                <li>
                  <a href="#">PHP</a>
                </li>
                <li>
                  <a href="#">MySQL</a>
                </li>
                <li>
                  <a href="#">MongoDB</a>
                </li>
              </ul>
            </li>
            <li>
              <a class="nav-link scrollto" href="#pricing">
                Trainings
              </a>
            </li>
            <li class="dropdown">
              <a class="nav-link scrollto" href="#speakers">
                <span>Team</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul>
                <li>
                  <a href="#">Frontend Engineer</a>
                </li>
                <li>
                  <a href="#">Database Administrator</a>
                </li>
                <li>
                  <a href="#">Backend Engineer</a>
                </li>
                <li>
                  <a href="#">Designer</a>
                </li>
              </ul>
            </li>
            <li>
              <a class="nav-link scrollto" href="#contact">
                Contact
              </a>
            </li>
          </ul>
          <i class="bi bi-list mobile-nav-toggle"></i>
        </nav>
      </div>
    </header>
  );
}

export default Header;
